import { Dialog as BaseDialog } from '@base-ui/react/dialog';

import { Card } from './card.tsx';

// oxlint-disable-next-line react-refresh/only-export-components
const DialogRoot = (props: React.ComponentProps<typeof BaseDialog.Root>) => {
  return <BaseDialog.Root {...props} />;
};

// oxlint-disable-next-line react-refresh/only-export-components
const DialogContent = (props: React.ComponentProps<typeof BaseDialog.Popup>) => {
  return (
    <BaseDialog.Portal>
      <BaseDialog.Backdrop
        className="fixed inset-0 min-h-dvh bg-black opacity-20 transition-all duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0 supports-[-webkit-touch-callout:none]:absolute dark:opacity-70"
        data-slot="dialog-backdrop"
      />
      <BaseDialog.Viewport>
        <BaseDialog.Popup
          className="fixed top-[calc(50%+1.25rem*var(--nested-dialogs))] left-1/2 -mt-8 w-md max-w-[calc(100vw-3rem)] -translate-x-1/2 -translate-y-1/2 scale-[calc(1-0.1*var(--nested-dialogs))] rounded-lg transition-all duration-150 outline-none data-ending-style:scale-90 data-ending-style:opacity-0 data-nested-dialog-open:after:absolute data-nested-dialog-open:after:inset-0 data-nested-dialog-open:after:rounded-[inherit] data-nested-dialog-open:after:bg-black/5 data-starting-style:scale-90 data-starting-style:opacity-0"
          {...props}
        />
      </BaseDialog.Viewport>
    </BaseDialog.Portal>
  );
};

export const CardDialog = {
  Root: DialogRoot,
  Trigger: BaseDialog.Trigger,
  Content: DialogContent,
  Card: Card,
  Title: BaseDialog.Title,
  Description: BaseDialog.Description,
  Close: BaseDialog.Close,
  createHandle: BaseDialog.createHandle,
};
